'use client';

import { IntroBox as SharedIntroBox } from '../shared/intro-box';

export function IntroBox() {
  const detailedContent = (
    <>
      <p>
        This section tracks operational behavior that affects your warranty
        coverage — even if your supplier remains compliant.
      </p>

      <p>
        The <strong>Penalty Overview</strong> highlights cases where your system
        operated outside the boundaries required by your warranty agreement.
        These conditions might include excessive cycling, high state of charge
        (SOC), or temperature spikes.
      </p>

      <p>
        Violations here lead to a{' '}
        <strong>degradation of the guaranteed performance</strong>, often
        modeled as "penalty points" against your State of Health (SOH) warranty.
        The more frequent or severe the deviation, the higher the impact.
      </p>

      <ul className="list-inside list-disc space-y-1">
        <li>
          This <strong>does not void the warranty</strong>, but reduces the
          level of performance that remains covered.
        </li>
        <li>
          If these behaviors continue or escalate, they may ultimately lead to{' '}
          <strong>warranty invalidation</strong>, shown separately.
        </li>
      </ul>

      <p className="text-muted-foreground">
        Monitoring and addressing these penalties early helps protect long-term
        warranty value.
      </p>
    </>
  );

  return (
    <SharedIntroBox
      title="Penalty Overview"
      dialogTitle="Operational Penalties"
      dialogDescription="How deviations from operational conditions affect warranty performance guarantees."
      detailedContent={detailedContent}
    >
      shows deviations from optimal operational conditions that contribute to a{' '}
      <em>reduction of the guaranteed performance</em> under warranty. These
      penalties are calculated based on severity and frequency of violations.
    </SharedIntroBox>
  );
}
